import { PageController } from '@client/components/_core/layout/PageController';
import { ProductVersionContactTypeEdit } from '@client/components/products-v2/ProductVersionContactTypeEdit';
import { productVersionFormStore } from '@client/components/products-v2/store';
import { useNavigate } from '@client/hooks/navigation/useNavigate';
import { createFileRoute } from '@tanstack/react-router';
import { useEffect } from 'react';

export const Route = createFileRoute(
    '/console/$orgId/configuration/claims-products/products-v2/details/$productId/product-versions/details/$productVersionId/contact-types/add',
)({
    staticData: {
        presentation: 'overlay',
        metadata: {
            title: 'Add contact type',
        },
    },

    component: RouteComponent,
});

function RouteComponent() {
    const isReadonly = productVersionFormStore.use.isReadonly();
    const navigate = useNavigate();

    useEffect(() => {
        if (isReadonly) {
            navigate({ moveInMatches: -1 });
        }
    }, [isReadonly]);

    return (
        <PageController route={Route}>
            {isReadonly ? null : <ProductVersionContactTypeEdit action={['add']} />}
        </PageController>
    );
}
